import React, { useRef } from 'react';
import { Card, Row, notification } from 'antd';
import emailjs from '@emailjs/browser';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';

const QueriesComponent = () => {
  const refForm = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();

    const serviceId = "service_jidzp8a";
    const templateId = "template_1zls6hf";
    const apiKey = "AVG2FVwSVQnMO-39e";

    emailjs.sendForm(serviceId, templateId, refForm.current, apiKey)
      .then(result => {
        console.log(result.text);
        notification.success({
          message: 'Mensaje enviado',
          description: 'Tu mensaje se ha enviado correctamente.'
        });
      })
      .catch(error => {
        console.error(error);
        notification.error({
          message: 'Error',
          description: 'Hubo un problema al enviar tu mensaje. Por favor, inténtalo de nuevo.'
        });
      });
  };

  return (
    <div className="queries-container">
      <h2 className="queries-title">Contáctanos</h2>
      <p className="queries-text">La gestión de los Acuerdos Transformativos se lleva a cabo desde la Subdirección Técnica, de Cooperación Bibliotecaria y Servicios a Distancia.</p>
      <p className="queries-text">Personas de contacto:</p>
      <div className="persona-contacto">
        <UserOutlined /> Ignacio del Pino
        <span className="extension">
          <PhoneOutlined /> Ext.: 4158
        </span>
      </div>
      <div className="persona-contacto">
        <UserOutlined /> Gema Martínez
        <span className="extension">
          &nbsp;<PhoneOutlined /> Ext.: 4166
        </span>
      </div>
      <p className="queries-text" style={{marginTop: "0.7cm"}}>También puedes enviarnos tu consulta, sugerencia o notificación de errores en los datos de las revistas a través del siguiente formulario:</p>
      <Row className='cajas-centradas'>
        <Card className='contact-card'>
          <form ref={refForm} onSubmit={handleSubmit} className='contact-form'>
            <fieldset className='form-field'>
              <label htmlFor='username'>Nombre <span style={{ color: 'red' }}>*</span></label>
              <input name='username' type="text" id="username" placeholder="Tu nombre" required />
            </fieldset>

            <fieldset className='form-field'>
              <div className="inline-inputs">
                <div className="inline-input">
                  <label htmlFor="email">Email <span style={{ color: 'red' }}>*</span></label>
                  <input type="email" id="email" name="email" placeholder="Tu email" required />
                </div>
                <div className="inline-input">
                  <label htmlFor="phone">Teléfono</label>
                  <input type="tel" id="phone" name="phone" placeholder="Tu teléfono" />
                </div>
                <div className="inline-input">
                  <label htmlFor="extension">Extensión</label>
                  <input type="text" id="extension" name="extension" placeholder="Tu extensión" />
                </div>
              </div>
            </fieldset>

            <fieldset className='form-field'>
              <label htmlFor="message">Mensaje <span style={{ color: 'red' }}>*</span></label>
              <textarea maxLength="500" placeholder='Tu mensaje' name='message' id='message' cols="30" rows="4" required></textarea>
            </fieldset>

            <div className='form-button-container'>
              <button className='button' type='submit'>Enviar</button>
            </div>
          </form>
        </Card>
      </Row>
    </div>
  );
};

export default QueriesComponent;

